import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import Gists from './Gists';
import Repos from './Repos';
import SearchBar from './searchBar';
import Profile from './Profile';
import Followers from './followers';
import Following from './Following';
import { tabs } from './tabsData'

export default function UserPage() {
    let { ParamUser } = useParams();
    const [user, setUser] = useState(ParamUser);
    const [tabActive, setTabActive] = useState('Repositories');

    function tabButton(event, name) {
        event.preventDefault();
        setTabActive(name);
      }

    useEffect(() => {
    if(user == null)
        document.title = 'GitHub User';
    else
        document.title = 'GitHub User · '+ user;
    }, [user])

  return(
    <div id='container'>
      <Header/>
      <SearchBar/>
      <div id='body-padding' style={user != null ? {} : { display: 'none'}}>
        <Profile username={user}/>
        <div className='center padding-bottom10'>
          {tabs.map((tab) => (
            <div key={tab.id} className={tabActive === tab.name ? 'tab-active' : ''}>
              <span>
                <button className='tab' onClick={(e) => tabButton(e, tab.name)} style={tabActive === tab.name ? {fontWeight: '600'} : {}}>{tab.svg} {tab.name}</button>
              </span>
            </div>
          ))}
        </div>
        <div style={tabActive === 'Repositories' ? {} : {display: 'none'}}>
          <Repos username={user}/>
        </div>
        <div style={tabActive === 'Gist' ? {} : {display: 'none'}}>
          <Gists username={user}/>
        </div>
        <div style={tabActive === 'Followers' ? {} : {display: 'none'}}>
          <Followers username={user} setUser={setUser}/>
        </div>
        <div style={tabActive === 'Following' ? {} : {display: 'none'}}>
          <Following username={user} setUser={setUser}/>
        </div>
      </div>
      <Footer/>
    </div>      
  )
} 
